/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Steps, Modal, message } from "antd";
import _, { uniq } from "lodash";
import { useParams } from "react-router-dom";
import UserCreateForm from "../../components/Users/UserCreate/UserCreateForm";
import {
  findErrorField,
  userSteps,
  hotelUserData,
  preprocessHmgData,
  preprocessProjectData,
} from "./utils/utils";
import {
  setInitialValueRoles,
  detailFormSetFields,
  updateSendValuesHandler,
  setInitialValueCustomPermission,
} from "../../components/UserPermission/Utils/Utils";
import { getmanagementGroupIndexes } from "../../components/UserPermission/Utils/getManagementGroupIndex";
import { generateIndexPermission } from "../../components/UserPermission/Utils/indexPermissionHandler";
import {
  checkUserNameAvailable,
  getEnvelopeSignerHotels,
} from "../../api/user";
import { CardElement } from "../../components/Common/UIElements";
import {
  useCheckUserNameAvailable,
  useCreateUser,
  useGetHotelList,
  useGetUsersByIdOrRoleId,
  useUpdateUser,
} from "../../hooks";
import { getRolesMappedToHMG } from "../../api/hmg";
import { useGetMainRoles, useGetRoles } from "../../hooks/roles.hook";
import useQuery from "../../hooks/url.hooks";
import { useRemoveFromEnvelopSigners } from "../../hooks/signature.hooks";
import Loading from "../../components/LoadingPage";
import { useGetAllApplications } from "../../hooks/applications.hooks";
import { useGetAllApplicationRolesData } from "../../hooks/applicationRoles.hook";

const { Step } = Steps;
const { confirm } = Modal;

const showConfirm = () => {
  return new Promise((resolve, reject) => {
    confirm({
      content: (
        <div>
          User has been given access to <b>multiple HMGs.</b>
{' '}
Are you sure you
          want to continue?
</div>
      ),
      icon: null,
      okText: "Yes",
      cancelText: "Cancel",
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
    });
  });
};

const hotelDeallocationModal = (statusMessage, isSingleSigner) => {
  return new Promise((resolve, reject) => {
    const okStatus = isSingleSigner ? "OK" : "Yes";
    confirm({
      content: <div>{statusMessage}</div>,
      icon: null,
      okText: okStatus,
      cancelButtonProps: isSingleSigner && { style: { display: "none" } }, // Hide cancel button by setting its display to none.
      onOk() {
        resolve(!isSingleSigner);
      },
      onCancel() {
        resolve(false);
      },
    });
  });
};

const UserCreateAndUpdate = () => {
  const permission = useSelector((state) => state.api.permission);
  const smUserData = useSelector((state) => state.api.smData);
  const { id } = useParams();
  const query = useQuery();

  const [current, setCurrent] = useState(0);
  const [create, setCreate] = useState(true);
  const [userData, setUserData] = useState(null);
  const [selectData, setSelectData] = useState({ app_roles: [] });
  const [finish, setFinish] = useState(false);
  const [smuserhotels, setSmUserHotels] = useState([]);
  const [smUserHmgs, setSmUserHmgs] = useState([]);
  const [smuserprojects, setSmUserProjects] = useState([]);
  const [smMappedRoles, setSmMappedRoles] = useState([]);
  const [mainRolesGetData, setMainRolesGetData] = useState([]);
  const [disabledState, setDisabledState] = useState(true);
  const [indexList, setIndexList] = useState([]);
  const [indexPermissions, setIndexPermissions] = useState({});
  const [indexEnabled, setIndexEnabled] = useState(false);
  const [not_allowed_project_list, setNotAllowedProjectList] = useState([]);
  const [createdUser, setCreatedUser] = useState("");
  const [assignedHotels, setAssignedHotels] = useState([]);
  const [formFormOneFormRef, setFormFormOneFormRef] = useState("");
  const [filteredRoles, setFilteredRoles] = useState([]);

  const steps = useMemo(() => {
    if (permission?.sm_solution_access) {
      return userSteps({ isAdmin: permission?.sm_solution_access });
    }
    return userSteps(false);
  }, [permission?.sm_solution_access]);

  const getDefaultHMG = (smUser = smUserData) =>
    smUser?.data?.corporate_user_hmg ?? undefined;

  const getRolesBasedOnMainRole = (selectMainRole) => {
    const roles =
      smMappedRoles?.filter(
        (data) => data?.main_role_id?._id === selectMainRole,
      ) ?? [];
    setFilteredRoles(roles);
  };

  const getMainRoleList = () => {
    const hmgMainRoles = [];
    for (let i = 0; i < smMappedRoles?.length; i++) {
      const isDuplicateMainRole = hmgMainRoles.find(
        (data) => data._id === smMappedRoles[i]?.main_role_id?._id,
      );

      if (!isDuplicateMainRole && smMappedRoles[i]?.main_role_id?._id) {
        const mainRole = {};
        mainRole._id = smMappedRoles[i]?.main_role_id?._id;
        mainRole.main_role_name =
          smMappedRoles[i].main_role_id.main_role_name ?? "";
        hmgMainRoles.push(mainRole);
      }
    }

    hmgMainRoles.sort((a, b) =>
      a?.main_role_name
        ?.toLowerCase()
        .localeCompare(b?.main_role_name?.toLowerCase()),
    );

    setMainRolesGetData(hmgMainRoles);
  };
  const setFormValues = async (result) => {
    if (result) {
      setFinish(false);
      setCreate(false);
      setSelectData(result);
      setCurrent(getStep());
      if (formFormOneFormRef) {
        let initialValue = null;
        if (result && result._id) {
          initialValue = result;
        }
        const roleselected = smMappedRoles.find(
          (e) => e._id === initialValue?.role_id ?? null,
        );
        formFormOneFormRef.setFieldsValue({
          _id: initialValue && initialValue._id ? initialValue._id : null,
          user_name:
            initialValue && initialValue.user_name
              ? initialValue.user_name
              : null,
          first_name:
            initialValue && initialValue.first_name
              ? initialValue.first_name
              : null,
          last_name:
            initialValue && initialValue.last_name
              ? initialValue.last_name
              : null,
          email: initialValue && initialValue.email ? initialValue.email : null,
          mobile:
            initialValue && initialValue.mobile ? initialValue.mobile : null,
          is_user_name:
            initialValue && initialValue.is_user_name
              ? initialValue.is_user_name
              : null,
          is_user_password:
            initialValue && initialValue.is_user_password
              ? initialValue.is_user_password
              : null,
          main_role:
            initialValue && initialValue.main_role_id
              ? initialValue.main_role_id
              : null,
          role:
            initialValue && initialValue.role_id ? initialValue.role_id : null,
          status: initialValue && initialValue.status ? "1" : "0",
          hotels:
            initialValue && initialValue.hotels_ids
              ? initialValue.hotels_ids
              : [],
          corporate_user_hmg:
            initialValue && initialValue.corporate_user_hmg
              ? initialValue.corporate_user_hmg
              : undefined,
          myp_user:
            roleselected?.role_data?.myp_permissions?.myp_solution_access ??
            false,
          pna_user:
            roleselected?.role_data?.mydocs_permissions
              ?.my_docs_solution_access ?? false,
          // myp_role:
          //   roleselected?.role_data?.myp_permissions?.myp_role ?? undefined,
          use_mfa:
            initialValue && initialValue.use_mfa ? initialValue.use_mfa : false,
          my_plan_user:
            roleselected?.role_data?.my_plan_permissions
              ?.my_plan_solution_access ?? false,
        });

        getMainRoleList();
        getRolesBasedOnMainRole(initialValue.main_role_id);
      }
    } else {
      getMainRoleList();
      const selectedData = {};
      if (permission?.sm_end_user_access) {
        selectedData.corporate_user_hmg = getDefaultHMG();
      }

      setFinish(false);
      setCreate(true);
      setSelectData({ app_roles: [] });
      setDisabledState(true);
      formFormOneFormRef.resetFields();
      if (formFormOneFormRef && permission?.sm_end_user_access) {
        formFormOneFormRef.setFieldsValue({
          corporate_user_hmg: selectedData.corporate_user_hmg,
        });
      }
    }
  };

  const { isLoading: isUserByIdDataLoading } = useGetUsersByIdOrRoleId(
    { user_id: id },
    {
      enabled: !!id && !!formFormOneFormRef,
      onSuccess: (res) => {
        if (res?.data?.length) {
          setUserData(res.data[0]);
        }
      },
    },
  );

  const { data: hotelList } = useGetHotelList({
    onSuccess: (res) => {
      if (res?.length) {
        const hotelUserDataSet = hotelUserData(res);
        const hmgDataSet = preprocessHmgData(res);
        const projectDataSet = preprocessProjectData(res);
        setSmUserHotels(hotelUserDataSet);
        setSmUserHmgs(hmgDataSet);
        setSmUserProjects(projectDataSet);
      }
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });
  const { data: rolesData, isLoading: isRolesDataLoading } = useGetRoles({
    enabled: !!formFormOneFormRef,
    onSuccess: (res) => {
      if (res?.data?.length > 0) {
        res.data.sort((a, b) =>
          a?.role_name
            ?.toLowerCase()
            .localeCompare(b?.role_name?.toLowerCase()),
        );
        setSmMappedRoles(res.data);
        setFilteredRoles(res.data);
      }
    },
  });

  const { data: mainRolesData, isLoading: isMainRolesLoading } =
    useGetMainRoles({
      onSuccess: (res) => {
        if (res?.data?.length) {
          res.data.sort((a, b) =>
            a?.main_role_name
              ?.toLowerCase()
              .localeCompare(b?.main_role_name?.toLowerCase()),
          );
          setMainRolesGetData(res.data);
        }
      },
    });

  const { mutateAsync: checkUserName, isLoading: isUserNameLoading } =
    useCheckUserNameAvailable({
      onError: (error) => {
        message.error(
          error.response?.data?.message ?? "Check User Available Error",
        );
      },
    });

  const { mutateAsync: mutateCreateUser, isLoading: isCreateUserLoading } =
    useCreateUser({
      onSuccess: () => {
        message.success("User Create Successfully");
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error");
      },
    });

  const { mutateAsync: mutateUpdateUser, isLoading: isUpdateUserLoading } =
    useUpdateUser({
      onSuccess: () => {
        message.success("User Update Successfully");
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "User did not update");
      },
    });

  const { mutateAsync: mutateRemoveSigners } = useRemoveFromEnvelopSigners();

  // Get Application List
  const { data: applicationData } = useGetAllApplications({
    select: (data) => {
      return data.sort((a, b) => {
        return a.app_name.localeCompare(b.app_name);
      });
    },

    onError: () => message.error("Application Data get Error"),
  });

  const { data: applicationRolesList } = useGetAllApplicationRolesData();

  const setIndexPermissionsHandler = (indexResult) => {
    setNotAllowedProjectList(indexResult.not_allowed_project_list);
    setIndexList(indexResult.indexList);
    setIndexPermissions(indexResult.indexPermissions);
    setIndexEnabled(indexResult.indexEnabled);
  };

  useEffect(() => {
    const fetchRoles = async () => {
      let mappedRoles = [];

      if (!permission?.sm_solution_access) {
        const hmgApiList = smUserHmgs.length > 0 ? smUserHmgs : [];
        try {
          const APIresult = await Promise.all(
            hmgApiList.map(async (hmg) => {
              const retrievedRoles = await getRolesMappedToHMG(hmg._id);
              if (!retrievedRoles.error) {
                return retrievedRoles.data;
              }
              message.error(retrievedRoles.message);
              return [];
            }),
          );
          mappedRoles = _.uniqBy(APIresult.flat(), "_id");
        } catch (error) {
          console.error("Error fetching roles:", error);
        }
      } else if (rolesData?.data) {
        mappedRoles = rolesData.data;
      }
      if (mappedRoles?.length > 0) {
        mappedRoles.sort((a, b) =>
          a?.role_name
            ?.toLowerCase()
            .localeCompare(b?.role_name?.toLowerCase()),
        );
        setSmMappedRoles(mappedRoles);
      }
    };

    fetchRoles();
  }, [permission, smUserHmgs, rolesData?.data]);

  useEffect(() => {
    const fetchData = async () => {
      if (formFormOneFormRef && rolesData?.data?.length) {
        if (userData?.custom_permission) {
          setInitialValueCustomPermission(userData);
          detailFormSetFields(userData, userData, formFormOneFormRef);
          setDisabledState(false);
          const userIndexResult = getmanagementGroupIndexes(userData);
          setIndexPermissionsHandler(userIndexResult);
        } else if (userData?.role_id) {
          const result = rolesData?.data?.find(
            (e) => e._id === userData.role_id,
          );
          setInitialValueRoles(result);
          const roleIndexResult = getmanagementGroupIndexes(
            userData,
            "role",
            result,
          );
          setIndexPermissionsHandler(roleIndexResult);
          detailFormSetFields(userData, userData, formFormOneFormRef);
        }
        await setFormValues(userData);
      }
    };

    fetchData();
  }, [formFormOneFormRef, userData, rolesData?.data]);

  const getStep = () => {
    let step = 0;
    const queryStep = query.get("step");
    if (queryStep) {
      const stepElement = steps.findIndex((el) => el.tag === queryStep);
      if (stepElement !== -1) {
        step = stepElement;
      }
    }
    return step;
  };

  const formFormOneSaveFormRef = (formRef) => {
    setFormFormOneFormRef(formRef);
  };

  const customFormRest = () => {
    if (formFormOneFormRef) {
      formFormOneFormRef.setFieldsValue({
        user_name: "",
      });
    }
  };

  const PermissionInitialValueHandler = (role) => {
    setInitialValueRoles(role);
    const value = {
      _id: formFormOneFormRef.getFieldValue("_id"),
      custom_permission: false,
    };

    detailFormSetFields(value, value, formFormOneFormRef);
  };

  const onMainRoleChange = () => {
    if (formFormOneFormRef) {
      formFormOneFormRef.setFieldsValue({
        role: undefined,
        myp_user: false,
        pna_user: false,
        my_plan_user: false,
      });
    }
  };

  const onRoleChange = (role_id) => {
    if (disabledState === false) {
      return null;
    }
    if (formFormOneFormRef) {
      const selectedRole = smMappedRoles.find((e) => e?._id === role_id);
      const setFields = {
        role: role_id,
        myp_user:
          selectedRole?.role_data?.myp_permissions?.myp_solution_access ??
          false,
        pna_user:
          selectedRole?.role_data?.mydocs_permissions
            ?.my_docs_solution_access ?? false,
        my_plan_user:
          selectedRole?.role_data?.my_plan_permissions
            ?.my_plan_solution_access ?? false,
      };
      if (
        setFields.myp_user &&
        selectedRole?.role_data?.myp_permissions?.myp_role
      ) {
        setFields.myp_role = selectedRole?.role_data?.myp_permissions?.myp_role;
      }
      formFormOneFormRef.setFieldsValue(setFields);
      PermissionInitialValueHandler(selectedRole);
    }
  };

  const onMainRoleSelect = (selectedMainRole) => {
    getRolesBasedOnMainRole(selectedMainRole);
  };

  const checkMultipleHMGsAssigned = (hotels) => {
    if (Array.isArray(hotels) && hotels.length > 1) {
      const filtered = smuserhotels
        .filter((el) => hotels.includes(el._id))
        .map((el) => el.hmg_id);
      const currentHmgList = [...new Set(filtered)];
      if (currentHmgList.length > 1) {
        if (Array.isArray(userData?.hotels) && userData?.hotels.length > 0) {
          const hotelIdList = userData?.hotels.map((el) => el._id);
          const initialHMGList = smuserhotels
            .filter((el) => hotelIdList.includes(el._id))
            .map((el) => el.hmg_id);
          const initialUniqueHMGList = [...new Set(initialHMGList)];
          return (
            currentHmgList.filter((hmg) => !initialUniqueHMGList.includes(hmg))
              .length > 0
          );
        }
        return currentHmgList.length > 1;
      }
    }
    return false;
  };

  const formFormOneSubmit = async (values) => {
    values.hotels = assignedHotels;
    // check multiple hmgs were assigned
    if (checkMultipleHMGsAssigned(values.hotels)) {
      const returnedval = await showConfirm();

      if (!returnedval) {
        return undefined;
      }
    }
    const stepValue = permission?.sm_solution_access ? 5 : 4;


    if (create) {
      const userPermission = await updateSendValuesHandler(values);

      const data = await mutateCreateUser({
        data: userPermission,
      });

      if (data) {
        formFormOneFormRef.resetFields();
        customFormRest();
        setCurrent(stepValue);
        setCreatedUser(data.data);
      }
    }

    if (!create) {
      const sendValues = await updateSendValuesHandler(values);

      sendValues.custom_permission_data.index_permissions = {
        index_permission_access: indexEnabled === true,
        permission_list:
          indexEnabled === true
            ? generateIndexPermission(indexPermissions)
            : [],
      };

      sendValues.custom_permission_data.project_permissions = {
        not_allowed_project_list,
      };

      const updatedUser = await mutateUpdateUser({ data: sendValues });
      if (updatedUser) {
        setCurrent(stepValue);
      }
    }
  };

  const updateCurrentStep = () => {
    setCurrent((prevCurrent) => prevCurrent + 1);
  };

  const next = () => {
    let proceedNext = false;
    formFormOneFormRef
      .validateFields()
      .then(async () => {
        proceedNext = true;
      })
      .catch((err) => {
        const currentStepId = current;
        let currentStep;
        let errorField;
        currentStep = steps.filter((data) => data.step_id === currentStepId);

        errorField = findErrorField(err.errorFields, `${currentStep[0].tag}`);

        if (currentStep && !errorField) {
          proceedNext = true;
        }
      })
      .finally(async () => {
        const formData = formFormOneFormRef.getFieldsValue([
          "_id",
          "user_name",
        ]);
        if (current === 0 && !formData?._id && proceedNext) {
          const isUserNameAvailable = await checkUserName({
            data: { user_name: formData.user_name },
          });
          if (
            isUserNameAvailable?.error &&
            isUserNameAvailable?.message === "Username Already Exist"
          ) {
            proceedNext = false;
            message.error(isUserNameAvailable?.message);
          }
        }

        if (proceedNext) {
          updateCurrentStep();
        }
      });
  };

  const assignHotelsHandler = (hotels) => {
    setAssignedHotels(hotels);
  };

  const indexPermissionHandler = (data) => {
    setIndexEnabled(data.isEnabled);
    setIndexPermissions(data.indexPermissions);
  };

  const hmgPermissionUpdate = (data) => {
    setIndexPermissions(data);
  };

  const prev = () => {
    setCurrent((prevCurrent) => prevCurrent - 1);
  };

  const getDeactivateMessage = (userSignerStatus) => {
    let message = "";
    const singleUsersString = `'${userSignerStatus.singleUsers.join("', '")}'`;
    const multipleUsersString = `'${userSignerStatus.multipleUsers.join(
      "', '",
    )}'`;
    if (
      userSignerStatus.singleUsers?.length &&
      userSignerStatus.multipleUsers?.length
    )
      message = (
        <p>
          This user is the signer of the following hotel(s):
          <b>{multipleUsersString}</b> and only signer for the following
          hotel(s):
          <b>{singleUsersString}</b>
{' '}
please replace the signer before
          deactivating the user.
</p>
      );
    else if (userSignerStatus.singleUsers?.length) {
      message = (
        <p>
          This user is the only signer for the following hotel(s):
          <b>{singleUsersString}</b> and must be replaced before deactivating.
        </p>
      );
    } else if (userSignerStatus.multipleUsers?.length) {
      message = (
        <p>
          This action will deallocate the user from Signature for following
          hotel(s): <b>{multipleUsersString}</b>
        </p>
      );
    }
    return message;
  };

  const checkUserUsesHotel = async (moveKeys) => {
    if (!selectData || !selectData._id) {
      return true;
    }

    const userSignerStatus = await getEnvelopeSignerHotels({
      id: selectData._id,
      hotelIds: moveKeys,
    });

    if (
      !userSignerStatus?.singleUsers.length &&
      !userSignerStatus?.multipleUsers.length
    ) {
      return true;
    }

    const statusMessage = getDeactivateMessage(userSignerStatus);
    const isSingleSigner = !!userSignerStatus?.singleUsers.length;
    const removeSigner = await hotelDeallocationModal(
      statusMessage,
      isSingleSigner,
    );
    // Check This API Call is working properly
    if (removeSigner) {
      const removeUserFromEnvelopeSignersResponse = await mutateRemoveSigners({
        id: selectData._id,
        hotel_ids: moveKeys,
      });

      return !!removeUserFromEnvelopeSignersResponse;
    }
    return false;
  };

  const formOnFinshFailed = (errInfo) => {
    if (errInfo) {
    }
  };
  const defaultPermissionOnChange = (checked) => {
    setDisabledState(checked);
  };

  const set_not_allowed_project_list = (id, val) => {
    let list = not_allowed_project_list;
    if (!val) {
      list.push(id);
      list = uniq(list);
    } else {
      list = list.filter((el) => el !== id);
    }
    setNotAllowedProjectList(list);
  };

  const setInitialState = () => {
    setCurrent(0);
    formFormOneFormRef.resetFields();
    customFormRest();
  };
  const additionalParameters = {
    indexEnabled,
    setIndexEnabled,
    not_allowed_project_list,
    set_not_allowed_project_list,
  };
  const isAdmin = permission?.sm_solution_access ?? false;
  return (
    <CardElement title={id ? "Update" : "Create"}>
      <Steps current={current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      {isRolesDataLoading ||
      isCreateUserLoading ||
      isUpdateUserLoading ||
      isUserNameLoading ? (
        <Loading />
      ) : null}

      <div style={{ marginBottom: 20 }} />

      <div className="steps-content">
        <UserCreateForm
          formData={formFormOneSaveFormRef}
          onFinishFailed={formOnFinshFailed}
          onFinish={formFormOneSubmit}
          defaultPermissionOnChange={defaultPermissionOnChange}
          disabledState={disabledState}
          rolesGetData={filteredRoles}
          mainRolesGetData={mainRolesGetData}
          onMainRoleChange={onMainRoleChange}
          onMainRoleSelect={onMainRoleSelect}
          onRoleChange={onRoleChange}
          hotelGetData={smuserhotels}
          hmgMainGetData={smUserHmgs}
          hmgGetData={smuserprojects}
          initialValue={selectData}
          createStatus={create}
          current={current}
          next={next}
          prev={prev}
          steps={steps}
          checkUserUsesHotel={checkUserUsesHotel}
          indexPermissions={indexPermissions}
          setIndexPermissions={setIndexPermissionsHandler}
          indexList={indexList}
          indexPermissionHandler={indexPermissionHandler}
          additionalParameters={additionalParameters}
          finish={finish}
          accessPermissions={permission}
          createdUser={createdUser}
          setInitialState={setInitialState}
          isAdmin={isAdmin}
          hmgPermissionUpdate={hmgPermissionUpdate}
          assignedHotels={assignedHotels}
          assignHotelsHandler={assignHotelsHandler}
          userId={id}
          applicationData={applicationData}
          applicationRolesList={applicationRolesList}
        />
      </div>
    </CardElement>
  );
};

export default UserCreateAndUpdate;
